import axios from "@/libs/api.request"

export const queryAllCamera = () => {
  return axios.request({
    url: 'video-service/api-v1.0/Camera/queryAllCamera',
    method: 'get'
  })
};

export const getAllEmplCamera = () => {
  return axios.request({
    url: 'video-service/api-v1.0/Camera/emplCamera/queryAllEmplCamera',
    method: 'get'
  })
}

export const getCamerasByAlarm = ({motion, helmet}) => {
  const params = {motionAlarm:motion,motionHelmet:helmet}
  return axios.request({
    url:'video-service/api-v1.0/Camera/queryCameraByAlarm',
    params,
    method:'get'
  })

}

export const getAllEmplCameraByUserId = ({userId}) => {
  return axios.request({
    url: 'video-service/api-v1.0/Camera/emplCamera/queryEmplCameraByUserId',
    method: 'get',
    params:{
      userId:userId
    }
  })
}

export const getRTMPURL = ({ip,port,userName, user, password, rs, channel,rtsp,transferType,voice}) => {
 const params = {
   ip,
   port,
   userName,
   user,
   password,
   rs,
   channel,
   rtsp,
   transferType,
   voice
 }
 return axios.request({
   url: 'video-service/api-v1.0/Camera/getRTMP',
   params,
   method: 'get',
   timeout: 10000
 })
}


export const stopRTMP = ({processId,userName})=>{
  const data = {
    processId,
    userName
  }
  return axios.request({
    url: 'video-service/api-v1.0/Camera/stopTransferForCheck',
    data,
    method:'post'
  })
}

export const releaseLine = ({processId,userName})=>{
  const data = {
    processId,
    userName
  }
  return axios.request({
    url: 'video-service/api-v1.0/Camera/release',
    data,
    method:'post'
  })
}

export const cleanCache = ({id,userName}) => {
  const params = {id,userName}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/clean',
    params,
    method:'get'
  })
}

/*record*/
export const queryAllRecording = ({userName}) => {
  const params = {
    userName
  }
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/videoRecording',
    params,
    method: 'get'
  })
}

export const queryIsRecording = ({rtsp,ip,port,callId}) =>{
  const data = {
    rtsp,
    ip,
    port,
    callId
  }
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/recording',
    data,
    method: 'post'
  })
}

export const videoRecord = ({rtsp,ip,port,employeeId,cameraId,userName,user,password,rs,channel},broadLog) => {
  const data = {
    rtsp,
    ip,
    port,
    employeeId,
    cameraId,
    userName,
    user,
    password,
    rs,
    channel
  }
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/videoRecord',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const stopVideoRecord = ({key,ip,userName}, broadLog) => {
  const data = {
    key,
    ip,
    userName
  }
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/stopVideoRecord',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const imageRecord = ({rtsp,ip,port,userName,employeeId,cameraId,user,password},broadLog) => {
  const data = {
    rtsp,
    ip,
    port,
    userName,
    employeeId,
    cameraId,
    user,
    password
  }

  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/imageRecord',
    data,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const queryAllImageRecord = ({userId}) => {
  const params = {
    userId
  }
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/queryImageRecord',
    params,
    method:'get'
  })
}
export const queryAllImageRecordForNew = (param) => {
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/queryImageRecordForPage',
    data:param,
    method:'post'
  })
}
export const queryAllVideoRecordForNew = (param) => {
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/queryVideoRecordForPage',
    data:param,
    method: 'post'
  })
}
export const queryAllVideoRecord = ({userId}) => {
  const params = {
    userId
  }
  return axios.request({
    url: 'video-service/api-v1.0/CameraRecord/queryVideoRecord',
    params,
    method: 'get'
  })
}

export const isSupportPtz = ({ip,port,user,password,channel}) => {
  const params = {ip,port,user,password,channel}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/ptz/isSupport',
    params,
    method: 'get'
  })
}

export const stopMove = ({ip,port,user,password,channel}) => {
  const data = {ip,port,user,password,channel}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/ptz/stopMove',
    data,
    method: 'post'
  })
}

export const cameraMove = ({ip,port,user,password,direction,x,y,moveType,channel}) => {
  const data = {ip,port,user,password,direction,x,y,moveType,channel}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/ptz/move',
    data,
    method: 'post'
  })
}

export const cameraZoom = ({ip,port,user,password,direction,zoom,moveType, channel}) => {
  const data = {ip,port,user,password,direction,zoom,moveType, channel}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/ptz/zoom',
    data,
    method: 'post'
  })
}

export const queryRTMPByExten = ({exten,cameraIds,type, userName,cameraAlarm}) => {
  const params = {exten,cameraIds,type,userName,cameraAlarm}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/queryRTMPByExten',
    params,
    method: 'get',
    timedout: 54000
  })
}
export const queryRTMPByPhone = ({phone}) => {
  const params = {phone}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/emplCamera/queryEmplCameraByPhone',
    params,
    method: 'get',
    timedout: 54000
  })
}

export const playNvrDevice = ({deviceId,channelId,protocol}) => {
  const data = {deviceId,channelId,protocol}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/play',
    data,
    method: 'post'
  })
}

export const playNvrMove = ({deviceId,channelId,direction,rate}) => {
  const data = {deviceId,channelId,direction,rate}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/ptz/move',
    data,
    method: 'post'
  })
}

export const playNvrRecord = ({callId,employeeId}) => {
  const data = {callId,employeeId}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/record',
    data,
    method: 'post'
  })
}

export const stopNvrRecord = ({callId,employeeId}) => {
  const data = {callId,employeeId}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/stopRecord',
    data,
    method: 'post'
  })
}
export const nvrScreenshot = ({callId,employeeId}) => {
  const data = {callId,employeeId}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/screenshot',
    data,
    method: 'post'
  })
}

export const nvrRelease = ({callId,uuid}) => {
  const data = {callId,uuid}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/release',
    data,
    method: 'post'
  })
}

export const getNvrInfoOfOne = ({deviceId}) => {
  const params = {deviceId}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/GB28181/get',
    params,
    method: 'get'
  })
};

export const updateVideoTour = (param,broadLog) => {
  return axios.request({
    url: 'video-service/api-v1.0/Camera/updateVideoTour',
    data:param,
    method: 'post',
    headers:{
      'Menu_id':broadLog.menu_id,
      'Sysuser_id':broadLog.sysuser_id,
      'Journal_title':encodeURIComponent(broadLog.journal_title)
    }
  })
}

export const queryVideoTour = ({userId}) => {
  const params = {userId}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/queryVideoTour',
    params,
    method: 'get'
  })
};

export const getCamerasUrlById = (param) => {
  return axios.request({
    url: 'video-service//api-v1.0/Camera/getCamerasUrlById',
    data:param,
    method: 'post',
  })
};

export const queryCameraAddress = (id) => {
  const params = {id}
  return axios.request({
    url: 'video-service/api-v1.0/Camera/playAddress',
    params,
    method:'get'
  })
}

export const getUseAndCameraList = (param) => {
  return axios.request({
    url: '/api/api_v2.2.5/conference/query/getUserAndCamera.json',
    data:param,
    method: 'post',
  })
};

/**
 * 根据摄像头名称获取流
 * @param name
 * @returns {*}
 */
export const queryUrlByName = (name) => {
  const params = {name:name}
  return axios.request({
    url:'video-service/api-v1.0/Camera/queryUrlByName',
    params,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/camera.js